import { useCallback } from "react"
import {
  Block,
  Button,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { setOnboardingFlow, useDappDispatch } from "#/redux-state"
import { usePosthogSignUpEvent } from "#/shared/hooks/posthog-events"
import { OnboardingFlow } from "#/shared/types"

import OnboardingModalReward from "./OnboardingModalReward"

type OnboardingModalFooterProps = {
  onSignUp: () => void
}

export default function OnboardingModalFooter({
  onSignUp,
}: OnboardingModalFooterProps) {
  const { emitSignUpStartedEvent } = usePosthogSignUpEvent()

  const dispatch = useDappDispatch()
  const [css, theme] = useStyletron()

  const signUpWithWalletHandler = useCallback(() => {
    emitSignUpStartedEvent()
    dispatch(setOnboardingFlow(OnboardingFlow.SIGN_UP))
    onSignUp()
  }, [dispatch, onSignUp, emitSignUpStartedEvent])

  return (
    <Block
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      })}
    >
      <ParagraphMedium
        marginBottom={theme.sizing.scale600}
        color={theme.colors.contentTertiary}
      >
        Don&apos;t have an account?{" "}
      </ParagraphMedium>
      <Button
        id="passport-sign_up"
        onClick={signUpWithWalletHandler}
        width="100%"
      >
        Sign up
      </Button>
      <OnboardingModalReward>Unlock reward</OnboardingModalReward>
    </Block>
  )
}
